import DeleteDocumentations from './deletedocumentations'

export default DeleteDocumentations